export const environment = {
  base_url: 'https://dev.service.authentication.verifiedge.com',
  allowed_origin: 'https://dev.app.authentication.verifiedge.com',
  dataLimit: '20',
  production: false,
};
